    document.addEventListener("DOMContentLoaded", function() {
        let headings = document.querySelectorAll(".article-template__content h2");
        if (headings.length > 0) {
            let tocContainer = document.createElement("div");
            tocContainer.classList.add("toc-container");
            tocContainer.innerHTML = "<h3>文章目錄</h3><ul></ul>";
            let tocList = tocContainer.querySelector("ul");
    
            headings.forEach((heading, index) => {
                let headingId = "section-" + (index + 1);
                heading.setAttribute("id", headingId);
                
                let listItem = document.createElement("li");
                let link = document.createElement("a");
                link.setAttribute("href", "#" + headingId);
                link.innerText = heading.innerText;
    
                listItem.appendChild(link);
                tocList.appendChild(listItem);
            });
    
            let articleContent = document.querySelector(".article-template__content");
            articleContent.insertAdjacentElement("beforebegin", tocContainer);
        }
    });